import AffiliatePanel from '../dashboard/pages/SettingsPage/AffiliatePanel/AffiliatePanel';
import BillingPanel from '../dashboard/pages/SettingsPage/BillingPanel/BillingPanel';
import { CancellationPanel } from '../dashboard/pages/SettingsPage/BillingPanel/CancellationPanel/CancellationPanel';
import { ManageSubsctiptionPanel } from '../dashboard/pages/SettingsPage/BillingPanel/ManageSubsctiptionPanel/ManageSubsctiptionPanel';
import { CompanyPanel } from '../dashboard/pages/SettingsPage/CompanyPanel/CompanyPanel';
import { MyAccountPanel } from '../dashboard/pages/SettingsPage/MyAccountPanel/MyAccountPanel';
import { Notifications } from '../dashboard/pages/SettingsPage/MyAccountPanel/Notifications/Notifications';
import UsersPanel from '../dashboard/pages/SettingsPage/UsersPanel/UsersPanel';

const BILLING_PATH_ROOT = '/settings/billing';

export const SettingsRoutes = {
  myAccount: {
    path: '/settings/my-account',
    component: MyAccountPanel,
    getLink: () => '/settings/my-account',
  },
  company: {
    path: '/settings/company',
    component: CompanyPanel,
    getLink: () => '/settings/company',
  },
  notifications: {
    path: '/settings/notifications',
    component: Notifications,
    getLink: () => '/settings/notifications',
  },
  billing: {
    path: BILLING_PATH_ROOT,
    component: BillingPanel,
    getLink: () => BILLING_PATH_ROOT,

    // Nested Routes
    cancel: {
      path: `${BILLING_PATH_ROOT}/cancel/:tabId/:pageId`,
      component: CancellationPanel,
      getLink: (tabId: string, pageId: number) =>
        `${BILLING_PATH_ROOT}/cancel/${tabId}/${pageId}`,
    },
    manageSubscrptions: {
      path: `${BILLING_PATH_ROOT}/manage-subscriptions/:tabId/:pageId?`,
      component: ManageSubsctiptionPanel,
      getLink: (tabId: string, pageId?: number) =>
        `${BILLING_PATH_ROOT}/manage-subscriptions/${tabId}/${pageId}`,
    },
  },
  users: {
    path: '/settings/users',
    component: UsersPanel,
    getLink: () => '/settings/users',
  },
  affiliates: {
    path: '/settings/referrals',
    component: AffiliatePanel,
    getLink: () => '/settings/referrals',
  },
};
